/**
 * Indicates whether or not the order was solicited.
 * tag: 377
 * @readonly
 * @enum {string} (Boolean)
 */
export enum SolicitedFlag {
  /** Was not solicited */
  WasNotSolicited = 'N',
  /** Was solicited */
  WasSolicited = 'Y',
}
